'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _Provider = require('../../helpers/Provider');

var _createLoginClient = require('../../helpers/createLoginClient');

var _createLoginClient2 = _interopRequireDefault(_createLoginClient);

var _ClientError = require('../../helpers/ClientError');

var _SessionStorage = require('../../helpers/SessionStorage');

var _Router = require('../../helpers/Router');

var _Login = require('../../helpers/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Preauthorize = require('../../helpers/Preauthorize');

var _SSO = require('../../helpers/SSO');

var _BasePostLoginFlowStrategy = require('./BasePostLoginFlowStrategy');

var _BasePostLoginFlowStrategy2 = _interopRequireDefault(_BasePostLoginFlowStrategy);

var _Features = require('../../helpers/Features');

var _Subscription = require('../../helpers/Subscription');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MusicPostLoginFlowStrategy = function (_BasePostLoginFlowStr) {
  (0, _inherits3.default)(MusicPostLoginFlowStrategy, _BasePostLoginFlowStr);

  function MusicPostLoginFlowStrategy() {
    (0, _classCallCheck3.default)(this, MusicPostLoginFlowStrategy);
    return (0, _possibleConstructorReturn3.default)(this, (MusicPostLoginFlowStrategy.__proto__ || (0, _getPrototypeOf2.default)(MusicPostLoginFlowStrategy)).apply(this, arguments));
  }

  (0, _createClass3.default)(MusicPostLoginFlowStrategy, [{
    key: 'handleUserInfoResponse',
    value: function handleUserInfoResponse(linkIdentityToAccount, linkSecureToken, linkSSOToken) {
      var auth = this.auth;
      var appInfo = this.appInfo;
      var log = this.log;
      var pushState = this.pushState;
      var oldSessionId = (0, _SessionStorage.getDataFromSessionStorage)(_SessionStorage.SessionStorageKeys.OldSessionId);
      var query = _url2.default.parse(window.location.href, true).query;
      var isPreauthorizeLink = (0, _Preauthorize.isPreauthorize)(query);
      var isSSO = _SSO.SSO.isSSO(query);

      if (oldSessionId) {
        var oldProvider = (0, _Provider.getProviderFromStorage)(_SessionStorage.SessionStorageKeys.LinkAccountProviderKey);
        // Link identity to account
        if (oldProvider && auth.userInfo.account && auth.userInfo.account.operatorId && oldProvider.id !== auth.userInfo.account.operatorId) {
          pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.SwitchProvider));
        } else {
          linkIdentityToAccount(oldSessionId);
        }
      } else if (isPreauthorizeLink || isSSO) {
        // Authorization
        if (auth.userInfo.account && auth.userInfo.account.operatorId && query.operator_id !== auth.userInfo.account.operatorId) {
          pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.SwitchProvider));
        } else if (isPreauthorizeLink) {
          linkSecureToken(query.token, query.operator_id);
        } else if (isSSO) {
          linkSSOToken(query.operatorToken, query.operator_id);
        }
      } else {
        var userInfo = auth.userInfo;
        if (userInfo) {
          if (userInfo.loginFlags && userInfo.loginFlags.AGREEMENTS_APPROVAL_REQUIRED) {
            pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.ApproveAgreements));
          } else if (userInfo.loginFlags && userInfo.loginFlags.MAILING_LIST_SELECTION_REQUIRED) {
            pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.Communication));
          } else if (auth.tvCode) {
            pushState(_Router.RouterConst.TVLoginSuccess);
          } else if (!userInfo.account.operatorId) {
            var features = appInfo.features;
            var freeModeAvailable = features && features.indexOf(_Features.FeaturesListConst.FreeModeAvailable) !== -1;

            // when free mode is available and user was not force to choose a provider, we redirect to the app and link free account
            if (freeModeAvailable && !auth.forceChooseProvider) {
              (0, _Login2.default)(auth.sessionId, auth, log, appInfo, pushState);
            } else {
              pushState((0, _Router.getPathWithWelcome)(_Router.RouterConst.TopProviders));
            }
          } else if (!(0, _Login.isUserAuthorize)(userInfo)) {
            var subscription = auth.userInfo.account.subscription;
            var hasStoreSubscription = subscription.subscriptionType === _Subscription.SubscriptionType.APP_STORE || subscription.subscriptionType === _Subscription.SubscriptionType.PLAY_STORE || subscription.subscriptionType === _Subscription.SubscriptionType.RECURLY || subscription.subscriptionType === _Subscription.SubscriptionType.GOODIE;
            var isStoreSubscriptionExpired = _Subscription.SubscriptionPlan.NONE === subscription.subscriptionPlan && hasStoreSubscription;

            // if store subscription is expired, we redirect to the app to show a popup and to link back to free mode
            if (isStoreSubscriptionExpired) {
              (0, _Login2.default)(auth.sessionId, auth, log, appInfo, pushState);
            } else {
              (0, _createLoginClient2.default)().then(function (loginClient) {
                return loginClient.operator.getOperator({
                  id: userInfo.account.operatorId,
                  languageTag: auth.lang,
                  clientId: auth.clientId
                }, { responseContentType: 'application/json' }).then(function (result) {
                  (0, _Provider.setProviderInStorage)(_SessionStorage.SessionStorageKeys.SelectedProviderKey, result.obj.operator);
                  pushState((0, _Router.getPathWithWelcome)((0, _Login.getAuthorizeRoute)(userInfo)));
                }).catch(function (error) {
                  (0, _ClientError.logClientErrorWithLoggingService)(error.statusText, new Error().stack, 'universal-loginError', auth);
                  pushState((0, _Router.getErrorRetryPath)());
                });
              }).catch(function (error) {
                (0, _ClientError.createLoginClientError)(error, new Error().stack, pushState, auth);
              });
            }
          } else {
            (0, _Login2.default)(auth.sessionId, auth, log, appInfo, pushState);
          }
        } else {
          (0, _ClientError.logClientErrorWithLoggingService)(auth.error || 'Error in MusicLoginStrategy', new Error().stack, 'universal-loginError', auth);
          pushState((0, _Router.getErrorRetryPath)());
        }
      }
    }
  }]);
  return MusicPostLoginFlowStrategy;
}(_BasePostLoginFlowStrategy2.default);

exports.default = MusicPostLoginFlowStrategy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/login/strategy/MusicPostLoginFlowStrategy.js
// module id = 2035
// module chunks = 0